var path = '/static/assets/khapps/articles/articles/partials/Article.html';
var html = "<div kh-loader=\"true\">\n    <div ng-include src=\"'/static/assets/khapps/articles/articles/partials/SingleArticleContent.html'\"></div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;